var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "20px",
    viewBox: "0 0 27 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9672584E-5E2A-4A35-BD1B-4FBBD95E39BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.329264323
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment",
    transform: "translate(-38.000000, -389.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credit-Card",
    transform: "translate(38.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75,13.3333333 L10.8,13.3333333 C11.5455844,13.3333333 12.15,12.7363797 12.15,12 C12.15,11.2636203 11.5455844,10.6666667 10.8,10.6666667 L6.75,10.6666667 C6.00441559,10.6666667 5.4,11.2636203 5.4,12 C5.4,12.7363797 6.00441559,13.3333333 6.75,13.3333333 Z M22.95,0 L4.05,0 C1.81324676,0 0,1.790861 0,4 L0,16 C0,18.209139 1.81324676,20 4.05,20 L22.95,20 C25.1867532,20 27,18.209139 27,16 L27,4 C27,1.790861 25.1867532,0 22.95,0 Z M24.3,16 C24.3,16.7363797 23.6955844,17.3333333 22.95,17.3333333 L4.05,17.3333333 C3.30441559,17.3333333 2.7,16.7363797 2.7,16 L2.7,8 L24.3,8 L24.3,16 Z M24.3,5.33333333 L2.7,5.33333333 L2.7,4 C2.7,3.26362033 3.30441559,2.66666667 4.05,2.66666667 L22.95,2.66666667 C23.6955844,2.66666667 24.3,3.26362033 24.3,4 L24.3,5.33333333 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.1fb199e482491e1abd7ce57b301d3ad2.svg";
export { ForwardRef as ReactComponent };